/**
 * Feeds API - Timeline
 *
 * Timeline feed endpoint.
 */

import { z } from 'zod'
import { PaginationParamsSchema } from '../common'
import { FeedActivitySchema } from './common'

// ============================================================================
// GET /v1/feeds/timeline
// ============================================================================

export const GetTimelineFeedRequestSchema = PaginationParamsSchema.extend({
  userId: z.string().optional()
})

export type GetTimelineFeedRequest = z.infer<typeof GetTimelineFeedRequestSchema>

export const GetTimelineFeedResponseSchema = z.object({
  data: z.array(FeedActivitySchema),
  message: z.string(),
  next: z.string().nullable().optional()
})

export type GetTimelineFeedResponse = z.infer<typeof GetTimelineFeedResponseSchema>
